import React, { useState } from 'react'
import './EventTickets.css'

const AddonsModal = ({
  isOpen,
  onClose,
  addons,
  isLoadingAddons,
  selectedAddons,
  handleAddonSelection,
  toggleMandatory,
  handleQuantityChange,
  handleVariantSelection,
  handleRemoveAddon,
}) => {
  const [searchTerm, setSearchTerm] = useState('')

  if (!isOpen) return null

  const isAddonSelected = (addon) => {
    if (!selectedAddons || !Array.isArray(selectedAddons)) {
      console.warn('selectedAddons is not an array:', selectedAddons)
      return false
    }
    const isSelected = selectedAddons.some((item) => item.id === addon.id)
    console.log(`Checking if addon ${addon.id} is selected:`, isSelected)
    return isSelected
  }

  const getAddonName = (addon) => {
    return addon.name || addon.add_on_name || ''
  }

  const getAddonDescription = (addon) => {
    return addon.description || ''
  }

  const getAddonPrice = (addon) => {
    if (addon.hasVariants && addon.variants && addon.variants.length > 0) {
      const prices = addon.variants.map((v) => v.price)
      if (prices.length === 1) return prices[0]
      return `${Math.min(...prices)} - ${Math.max(...prices)}`
    }
    return addon.price || 0
  }

  const filteredAddons = addons.filter(
    (addon) =>
      getAddonName(addon).toLowerCase().includes(searchTerm.toLowerCase()) ||
      getAddonDescription(addon)
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
  )

  return (
    <div className="addons-modal-backdrop" onClick={onClose}>
      <div
        className="addons-modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="addons-modal-header">
          <h5 className="addons-modal-title">Choose Add-ons</h5>
          <button
            type="button"
            className="addons-modal-close"
            onClick={onClose}
          >
            <span>×</span>
          </button>
        </div>
        <div className="addons-modal-body">
          <div className="addons-search-container">
            <input
              type="text"
              className="addons-search-input"
              placeholder="Search add-ons..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          {isLoadingAddons ? (
            <div className="addons-loading">
              <div className="addons-spinner"></div>
            </div>
          ) : filteredAddons.length === 0 ? (
            <div className="addons-empty">
              <p>No add-ons available</p>
            </div>
          ) : (
            <div className="addons-list">
              {filteredAddons.map((addon) => (
                <div
                  key={addon.id}
                  className={`addon-item ${
                    isAddonSelected(addon) ? 'addon-item-selected' : ''
                  }`}
                  onClick={() => handleAddonSelection(addon)}
                >
                  <div className="addon-checkbox">
                    <input
                      type="checkbox"
                      id={`addon-${addon.id}`}
                      className="custom-checkbox"
                      checked={isAddonSelected(addon)}
                      onChange={() => {}}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <label
                      htmlFor={`addon-${addon.id}`}
                      className="checkbox-label"
                    ></label>
                  </div>
                  <div className="addon-content">
                    <div className="addon-header">
                      <h6 className="addon-title">{getAddonName(addon)}</h6>
                      <div className="addon-price">
                        {addon.currency} {getAddonPrice(addon)}
                      </div>
                    </div>
                    {getAddonDescription(addon) && (
                      <p className="addon-description">
                        {getAddonDescription(addon)}
                      </p>
                    )}
                    {addon.hasVariants &&
                      addon.variants &&
                      addon.variants.length > 0 && (
                        <div className="addon-variants">
                          <span>Variants: </span>
                          {addon.variants.map((v) => v.name).join(', ')}
                        </div>
                      )}
                    {isAddonSelected(addon) && (
                      // <div className="addon-controls">
                      //   <div className="addon-quantity">
                      //     <label>Quantity: </label>
                      //     <input
                      //       type="number"
                      //       min="1"
                      //       value={
                      //         selectedAddons.find(
                      //           (item) => item.id === addon.id
                      //         )?.quantity || 1
                      //       }
                      //       onChange={(e) => {
                      //         const value = parseInt(e.target.value) || 1
                      //         if (value >= 1) {
                      //           handleQuantityChange(addon.id, value)
                      //         }
                      //       }}
                      //     />
                      //   </div>
                      //   <div className="addon-mandatory">
                      //     <label>
                      //       <input
                      //         type="checkbox"
                      //         checked={
                      //           selectedAddons.find(
                      //             (item) => item.id === addon.id
                      //           )?.isMandatory || false
                      //         }
                      //         onChange={() => toggleMandatory(addon.id)}
                      //       />
                      //       Mandatory
                      //     </label>
                      //   </div>
                      //   {addon.hasVariants &&
                      //     addon.variants &&
                      //     addon.variants.length > 1 && (
                      //       <div className="addon-variants-select">
                      //         <label>Variant: </label>
                      //         <select
                      //           value={
                      //             selectedAddons.find(
                      //               (item) => item.id === addon.id
                      //             )?.selectedVariant?.name ||
                      //             addon.variants[0].name
                      //           }
                      //           onChange={(e) => {
                      //             const selectedVariantName = e.target.value
                      //             const variantDetails = addon.variants.find(
                      //               (v) => v.name === selectedVariantName
                      //             )
                      //             if (variantDetails) {
                      //               handleVariantSelection(addon.id, {
                      //                 name: variantDetails.name,
                      //                 price: variantDetails.price,
                      //               })
                      //             }
                      //           }}
                      //         >
                      //           <option disabled value="">
                      //             -- Select Variant --
                      //           </option>
                      //           {addon.variants.map((v) => (
                      //             <option key={v.name} value={v.name}>
                      //               {v.name} - {addon.currency} {v.price}
                      //             </option>
                      //           ))}
                      //         </select>
                      //       </div>
                      //     )}
                      //   <button
                      //     className="btn btn-sm btn-link p-0 text-danger"
                      //     onClick={(e) => {
                      //       e.stopPropagation()
                      //       handleRemoveAddon(addon.id)
                      //     }}
                      //   >
                      //     <i className="fa fa-trash fs-6"></i>
                      //   </button>
                      // </div>
                      <></>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="addons-modal-footer">
          <button type="button" className="addons-btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="addons-btn-add" onClick={onClose}>
            Add Selected ({selectedAddons.length})
          </button>
        </div>
      </div>
    </div>
  )
}

export default AddonsModal
